import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { ApiUnsubscribeGroupsResponse } from './types';

type Props = { artistId: string };

export const getArtistUnsubscribeGroups = async ({ artistId }: Props) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/unsubscribe-groups`;

  const response = await api.executeGetRequest<ObjectResponse<ApiUnsubscribeGroupsResponse>>(url);

  return response.data;
};
